import { render, staticRenderFns } from "./GeometraSquadra.vue?vue&type=template&id=4ff248e2"
import script from "./GeometraSquadra.vue?vue&type=script&lang=js"
export * from "./GeometraSquadra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports